/* eslint-disable arrow-parens */
import { forwardRef, JSXElementConstructor, ReactElement, useState, useContext, useCallback } from "react";
import { ThemeContext } from "../../../../contexts";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

// import "./customFormDialog.css";
import { CustomDateTimePickerDialogProps } from "../../../../types/components/dialogProps.types";
import { api } from "../../../../utils/api";
import { BBICounselorSchedule } from "../../../../assets";

const Transition: JSXElementConstructor<TransitionProps & { children: ReactElement<any, any> }> | undefined =
	forwardRef(function Transition(props, ref) {
		return <Slide direction="up" ref={ref} {...props} />;
	});

const DateTimePickerDialog = ({ customDateTimePickerDialogProps, handleClose }: CustomDateTimePickerDialogProps) => {
	const { openDialog, title, actions } = customDateTimePickerDialogProps;
	const { theme } = useContext(ThemeContext);
	const [value, setValue] = useState<Dayjs | null>(dayjs("2018-01-01T00:00:00.000Z"));

	const handleDateTimeChange = (dateTimeValue: dayjs.Dayjs | null, keyboardInputValue?: string | undefined) => {
		// console.log("dateTimeValue", dateTimeValue);
		setValue(dateTimeValue);
	};

	const handleScheduleButtonClick = useCallback(async () => {
		// window.open("https://schedapple.com/appointment/12455?location=1&service=15&staff=&hide_go_back=y", "_blank");
		window.open("https://schedapple.com/appointment/12455?location=2&service=&staff=&hide_go_back=n", "_blank");
		handleClose();
		// const payload = {
		// 	date_time: value as unknown as string
		// };
		// const response = await api.email.scheduleAppointment(payload);
		// if (response) {
		// 	alert("Succesfully scheduled appointmet! Our Agent will get in touch with you");
		//
		// }
	}, [handleClose]);

	return (
		<Dialog open={openDialog} onClose={handleClose}>
			{/* <DialogTitle>{title}</DialogTitle> */}
			<DialogContent>
				<b>
					During Open Enrollment, you have two great options for assistance! Meet with our onsite Benefit
					Counselors or speak with one of our experts through our Call Center by calling 833-356-0852 M-F 8 am
					to 6 pm Central. We&#39;re here to help you make the best choices for your benefit!
				</b>
				{/* <LocalizationProvider dateAdapter={AdapterDayjs}>
					<MobileDateTimePicker
						// label="For mobile"
						value={value}
						onChange={handleDateTimeChange}
						renderInput={(params) => (
							<TextField
								{...params}
								fullWidth
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<CalendarTodayIcon style={{ cursor: "pointer" }} />
										</InputAdornment>
									)
								}}
							/>
						)}
					/>
				</LocalizationProvider> */}
			</DialogContent>
			<DialogActions>
				<Button
					variant="contained"
					onClick={() => {
						handleClose();
						window.open(BBICounselorSchedule, "_blank");
					}}
					style={{
						backgroundColor: theme.primary_color, //"#44b700" --> Green Color
						letterSpacing: "1px",
						fontSize: "0.7rem",
						fontWeight: "bold",
						color: "#ffff",
						marginRight: 10,
						marginLeft: 5
					}}
				>
					Check The Schedule
				</Button>
				<Button
					variant="contained"
					onClick={() => handleClose()}
					style={{
						backgroundColor: theme.primary_color, //"#44b700" --> Green Color
						letterSpacing: "1px",
						fontSize: "0.7rem",
						fontWeight: "bold",
						color: "#ffff",
						marginRight: 10,
						marginLeft: 5
					}}
				>
					Ok
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default DateTimePickerDialog;
